import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetData_queueCount = z.any()
export type TagsGetData_queueCount = z.infer<typeof tagsGetData_queueCount>

export const descriptionGetData_queueCount = z.any()
export type DescriptionGetData_queueCount = z.infer<typeof descriptionGetData_queueCount>

export const responseGetData_queueCount = z.object({ "payload": z.array(z.object({ "count": z.number(), "type": z.enum(["consumption","invoice"]), "buildingId": z.string() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetData_queueCount = z.infer<typeof responseGetData_queueCount>

interface IGetData_queueCount extends BaseMethodType {
  tags: TagsGetData_queueCount,
  description: DescriptionGetData_queueCount,
  response: ResponseGetData_queueCount
}
export const URL = '/data-queue/count'
export const validation = {
  get: {
    tags: tagsGetData_queueCount,
    description: descriptionGetData_queueCount,
    response: responseGetData_queueCount
  }
}
export interface Data_queueCount extends BaseRouteType {
  get: IGetData_queueCount
}